import { useFlags } from "features/api/flags"

export function useIsProductAvailabilityEnabled(): boolean {
  const { ENABLE_PRODUCT_AVAILABILITY_BY_LOCATION } = useFlags()
  return ENABLE_PRODUCT_AVAILABILITY_BY_LOCATION.boolVal
}
